// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__13gPi","inputWrap":"CustomTip_inputWrap__o6WXy"};